import { Link } from 'react-router-dom';
import { FC } from 'react';


interface IProps {
  crumbs: { page: string; link?: string }[];
}

const Breadcrumbs: FC<IProps> = (props) => {
  const { crumbs } = props;
  return (
    <div className="container">
      <ol className="breadcrumb">
        <li><a href="/">Home</a></li>
        {crumbs.map(({ page, link }, i) => {
          if (link) {
            return (
              <li className={i === crumbs.length - 1 ? 'active' : ''} key={i}>
                <Link to={link}>{page}</Link>
              </li>
            )
          }
          return (
            <li className={i === crumbs.length - 1 ? 'active' : ''} key={i}>
              {page}
            </li>
          );
        })}
      </ol>
    </div>
  );
}

export default Breadcrumbs;